import { Box } from '@mui/material'
import SentMessageReplyPreview from './SentMessageReplyPreview'
import UserChatBubbleEditSurface from './UserChatBubbleEditSurface'
import UserChatBubbleClamp from './UserChatBubbleClamp'
import styles from './index.module.scss'

export default function UserChatBubbleMorphBubble({
  isEditing,
  draftText,
  onDraftTextChange,
  onCancelEdit,
  onSendEdit,
  replyTo,
  onJumpToQuotedMessage,
  children,
}) {
  return (
    <Box
      className={`${styles.morphSurface} ${isEditing ? styles.morphSurfaceEdit : styles.morphSurfaceView}`}
      aria-label={isEditing ? 'Edit message' : undefined}
    >
      {isEditing ? (
        <UserChatBubbleEditSurface
          draftText={draftText}
          onDraftTextChange={onDraftTextChange}
          onCancelEdit={onCancelEdit}
          onSendEdit={onSendEdit}
        />
      ) : (
        <Box className={styles.bubbleInner}>
          {replyTo || children ? (
            <Box className={`${styles.inner} ${replyTo ? styles.innerStack : ''}`}>
              {replyTo ? (
                <SentMessageReplyPreview replyTo={replyTo} onJumpToQuotedMessage={onJumpToQuotedMessage} />
              ) : null}
              {children ? (
                <Box className={styles.frame}>
                  <UserChatBubbleClamp>{children}</UserChatBubbleClamp>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Box>
      )}
    </Box>
  )
}
